import { SizeGuideSection } from "../size-guide-section"

// src/components/size-guide-new/kids/boots.tsx
const kidsBootsTableData = {
  headers: [
    [
      {
        content: "US Sizes"
      },
      {
        content: "Euro Sizes"
      },
      {
        content: "UK Sizes"
      },
      {
        content: "Inches"
      },
      {
        content: "CM"
      }
    ]
  ],
  data: [
    [
      { content: "0K" },
      { content: "15" },
      { content: "0" },
      { content: "3.3" },
      { content: "7.9" }
    ],
    [
      { content: "1K" },
      { content: "16" },
      { content: "0.5" },
      { content: "3.5" },
      { content: "8.9" }
    ],
    [
      { content: "2K" },
      { content: "17" },
      { content: "1" },
      { content: "3.8" },
      { content: "9.5" }
    ],
    [
      { content: "3K" },
      { content: "18" },
      { content: "2" },
      { content: "4.3" },
      { content: "10.5" }
    ],
    [
      { content: "4K" },
      { content: "19" },
      { content: "3" },
      { content: "4.5" },
      { content: "11.4" }
    ],
    [
      { content: "5K" },
      { content: "20" },
      { content: "4" },
      { content: "4.8" },
      { content: "12.1" }
    ],
    [
      { content: "6K" },
      { content: "21" },
      { content: "5" },
      { content: "5.1" },
      { content: "13" }
    ],
    [
      { content: "7K" },
      { content: "22" },
      { content: "6" },
      { content: "5.5" },
      { content: "14" }
    ],
    [
      { content: "8K" },
      { content: "23" },
      { content: "7" },
      { content: "5.8" },
      { content: "14.6" }
    ],
    [
      { content: "9K" },
      { content: "24" },
      { content: "8" },
      { content: "6.1" },
      { content: "15.6" }
    ],
    [
      { content: "10K" },
      { content: "25" },
      { content: "9" },
      { content: "6.5" },
      { content: "16.5" }
    ],
    [
      { content: "11K" },
      { content: "26" },
      { content: "10" },
      { content: "6.8" },
      { content: "17.1" }
    ],
    [
      { content: "12K" },
      { content: "27" },
      { content: "11" },
      { content: "7.1" },
      { content: "18.1" }
    ],
    [
      { content: "13K" },
      { content: "28" },
      { content: "12" },
      { content: "7.5" },
      { content: "19.1" }
    ],
    [
      { content: "1" },
      { content: "29" },
      { content: "13" },
      { content: "7.8" },
      { content: "19.7" }
    ],
    [
      { content: "2" },
      { content: "30" },
      { content: "1" },
      { content: "8.1" },
      { content: "20.3" }
    ],
    [
      { content: "3" },
      { content: "31" },
      { content: "2" },
      { content: "8.5" },
      { content: "21.6" }
    ],
    [
      { content: "4" },
      { content: "32" },
      { content: "3" },
      { content: "8.8" },
      { content: "22.2" }
    ],
    [
      { content: "5" },
      { content: "33" },
      { content: "4" },
      { content: "9.1" },
      { content: "23.2" }
    ],
    [
      { content: "6" },
      { content: "34" },
      { content: "5" },
      { content: "9.5" },
      { content: "24.1" }
    ],
    [
      { content: "7" },
      { content: "35" },
      { content: "6" },
      { content: "9.8" },
      { content: "24.8" }
    ]
  ]
}

export const KidsBoots = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title="Boots"
    tableData={kidsBootsTableData}
    className={className}
  />
}
